const ColorData = {
  primary: {
    main: "#283165",
    strokeColor: "#ffffffff", // Semi-transparent white for stroke
  },
  secondary: {
    main: "#fff",
  },
  accent: {
    main: "#283165", // --accent-color (same as primary)
  },
  background: {
    default: "#fff", // --background-color
  },
  custom: {
    white: "#ffffff", // --white-color
    black: "#000000", // --black-color
  },
  text: {
    primary: "#000000", // --text-color
    secondary: "#ffffff", // --text-color-2
  },
  heading: {
    main: '#283165', // --heading-color
    contrast: '#000000', // --heading-color-2
  },
  hover: {
    main: '#2a3162', // --hover-color
  },
  stroke: {
    main: '#D4D4D4', // --stroke-color
    faint: '#ffffffff', // --f-stroke-color
  },
};

export default ColorData;
